module.exports = __webpack_public_path__ + "src/components/Footer/Banner.jpg?dff7756f";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Banner.jpg
// module id = 3092
// module chunks = 8